import React, {
  useState,
  useRef,
  useEffect,
  useField,
  Field,
  useId,
} from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import formimg from "../Forms/Performance-Appraisal-Templates-1-1013x439 1.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import SmartGoalimg from "../Forms/smart-business-goals1.png";
import Select from "react-select";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

function MainGoal() {
  const selectInputRef = useRef();
  const currentYear = new Date().getFullYear();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState();
  const [departmentsData, setDepartmentsData] = useState(null);
  const [options, setOptions] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  const [employeeinitalsdata, setEmployeesInitialData] = useState([]);
  const [assigneevalues, setAssigneeValues] = useState(null);
  const [selassigneevalues, setSelAssigneeValues] = useState(null);
  const [modifiedAssignees, setModifiedAssignees] = useState("");
  const [modifiedAssigneesUserIds, setModifiedAssigneesUserIds] = useState([]);
  const [selectedDepartmentid, setSelctedDepartmentid] = useState(null);
  // const [designation, setDesignation] = useState([]);
  const [designation, setDesignation] = useState("");
  const [allemployees, setAllEmployees] = useState([]);
  const [progress, setProgress] = useState("");
  const [isdeptselected, setIsDeptselected] = useState(false);
  const [isManager, setIsManager] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();
  const usernameRef = useRef(null);
  const [seldepartment, setSelDepartment] = useState(0);

  const handleRemoveAllOptions = () => {
    setAllEmployees([]);
  };
  let deptid = "";
  let desigid = "";
  const role = localStorage.getItem("userrole");
  let userid = localStorage.getItem("employeeid");
  let userDepartment = localStorage.getItem("departmentid");
  const isSpMgr = role === "ROLE_MANAGER" && userid === "8367";

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        if (role === "ROLE_MANAGER" && userid === "8367") {
          const response = await axios.get(
            `${baseURL}/getDepartmentsForMgr?id=${userDepartment}`
          );
          setOptions(response.data.departments);

          departmentChange(userDepartment);

          // new added - start

          // selectDeisgChange(userDepartment,'designation');
          // selectDepnChange(userDepartment, "designation");
          // deisgnationChange(userDepartment, "designation");

          const resp = await axios.get(
            `${baseURL}/getAllassigneesbydesignationandept?id=${userDepartment}&spMgr=true&ids=${
              userDepartment === "All" ? userDepartment : userDepartment
            }&designation=${"false"}`
          );
          if (resp) {
            setEmployeesData(resp.data.employees);
            setEmployeesInitialData(resp.data.employees);
            let assignees = resp.data.employees
              .map((employee) => employee.employeeid)
              .join(",");
            setAssigneeValues(assignees);
            setModifiedAssignees(assignees);

            let assigneesUserIds = resp.data.employees.map(
              (employee) => employee.user_id
            );
            setModifiedAssigneesUserIds(assigneesUserIds);
            setIsDeptselected(true);
            // alert(assignees);

            departmentChange(userDepartment);
            setSelDepartment(userDepartment);
          } else {
            console.error("Designation fetch failed");
          }

          // new added - end
        } else {
          const response = await axios.get(`${baseURL}/getdepartments`);
          setOptions(response.data.departments);
        }
      } catch (error) {
        console.error("Error fetching options:", error);
      }
      if (role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR") {
        setIsManager(true);
        if (userid === "8367") {
          setIsManager(false);
        }
        setSelctedDepartmentid(userDepartment);
      } else {
        setIsManager(false);
      }
    };
    fetchOptions();
    //  fetchDesignations();
  }, []);

  useEffect(() => {
    const fetchAssignees = async () => {
      try {
        let apiurl = `${baseURL}/getallassigneesfromuser`;
        let response = null;
        if (role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR") {
          response = await axios.get(`${baseURL}/getteamlist?id=` + userid);

          setAllEmployees(response.data.team);
           // setEmployeesData(response.data.team);
          setEmployeesInitialData(response.data.team);
        } else {
          response = await axios.get(apiurl);
          setAllEmployees(response.data.employees);
          setEmployeesInitialData(response.data.employees);
        }
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchAssignees();
    setSelctedDepartmentid("All");
    fetchDesignations();
    // deisgnationChange("All");
    deptid = "All";
  }, []);

  const fetchDesignations = async () => {
    try {
      const resp = await axios.get(`${baseURL}/getdeignations`);
      if (resp) {
        setDesignationData(resp.data.designations);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const departmentChange = async (dempartmentid) => {
    try {
      deptid = dempartmentid;

      const resp = await axios.get(
        `${baseURL}/getdesignationsbydepartment?deptid=` + deptid
      );
      if (resp) {
        let designations = resp.data.designations;
        setDesignationData(designations);
        setSelctedDepartmentid(dempartmentid);
        console.log("designationData set:", designations);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
    // getEmployeesforDepartment(dempartmentid);
    if (role !== "ROLE_MANAGER" && userid !== "8367") {
      deisgnationChangebyDept(dempartmentid);
    }
  };

  const deisgnationChange = async (designationid, designation) => {
    console.log(designation, "lllllllllllll");
    console.log(designationid, "designationid");
    try {
      // deisgnationChangebyDept()
      //alert(designationid);
      desigid = designationid;

      //console.log("inside designation change desigid.." +desigid);

      let selecteddesignation = designationid;
      //alert("selected  designation"+selecteddesignation);
      setDesignation(selecteddesignation);
      //selectInputRef.isMulti=true;
      if (designationid === "0") {
        selectInputRef.current.clearValue();

        return;
      }
      let resp;

      if (role === "ROLE_MANAGER" && userid === "8367") {
        console.log("first");
        console.log(
          "first 1111111111111",
          employeeinitalsdata
            .map((employee) => ({
              value: employee.employeeid,
              label: `${employee.FirstName} ${
                employee.LastName !== null ? employee.LastName : ""
              } - ${employee.employeeid}`,
              user_id: employee.user_id,
            }))
            .map((dep) => dep.value)
            .join(",")
        );

        const departmentIds =
          designation === "designation"
            ? employeeinitalsdata
                .map((employee) => ({
                  value: employee.employeeid,
                  label: `${employee.FirstName} ${
                    employee.LastName !== null ? employee.LastName : ""
                  } - ${employee.employeeid}`,
                  user_id: employee.user_id,
                }))
                .map((dep) => dep.value)
                .join(",")
            : options.map((dep) => dep.id).join(",");

        resp = await axios.get(
          `${baseURL}/getAllassigneesbydesignationandept?id=${
            designation === "designation" && designationid !== "All"
              ? seldepartment
              : designationid
          }&spMgr=true&ids=${
            designationid === "All" ? departmentIds : designationid
          }&designation=${designation === "designation" ? "true" : "false"}`
        );
        if (resp) {
          //alert("after axios selected designation:"+designation);
          // console.log(resp.data.employees, "resp.data.employees");
          setEmployeesData(resp.data.employees);
          setEmployeesInitialData(resp.data.employees);
          let assignees = resp.data.employees
            .map((employee) => employee.employeeid)
            .join(",");
          setAssigneeValues(assignees);
          setModifiedAssignees(assignees);

          let assigneesUserIds = resp.data.employees.map(
            (employee) => employee.user_id
          );
          setModifiedAssigneesUserIds(assigneesUserIds);

          setIsDeptselected(true);
          //   alert(assignees);
        } else {
          console.error("Designation fetch failed");
        }
      } else if (role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR") {
        console.log("second");
        resp = await axios.get(
          `${baseURL}/getAllassigneesbydesignationandept?id=` +
            designationid +
            "&did=" +
            selectedDepartmentid +
            "&m=1" +
            "&userid=" +
            userid
        );
        if (resp) {
          //alert("after axios selected designation:"+designation);
          setEmployeesData(resp.data.employees);
          setEmployeesInitialData(resp.data.employees);
          let assignees = resp.data.employees
            .map((employee) => employee.employeeid)
            .join(",");
          setAssigneeValues(assignees);
          setModifiedAssignees(assignees);

          let assigneesUserIds = resp.data.employees.map(
            (employee) => employee.user_id
          );
          setModifiedAssigneesUserIds(assigneesUserIds);
          setIsDeptselected(true);
          //   alert(assignees);
        } else {
          console.error("Designation fetch failed");
        }
      } else {
        console.log("third");
        resp = await axios.get(
          `${baseURL}/getAllassigneesbydesignationandept?id=` +
            designationid +
            "&did=" +
            selectedDepartmentid +
            "&m=0"
        );
        if (resp) {
          //alert("after axios selected designation:"+designation);
          setEmployeesData(resp.data.employees);
          setEmployeesInitialData(resp.data.employees);
          let assignees = resp.data.employees
            .map((employee) => employee.employeeid)
            .join(",");
          setAssigneeValues(assignees);
          setModifiedAssignees(assignees);

          let assigneesUserIds = resp.data.employees.map(
            (employee) => employee.user_id
          );
          setModifiedAssigneesUserIds(assigneesUserIds);
          setIsDeptselected(true);
          //   alert(assignees);
        } else {
          console.error("Designation fetch failed");
        }
      }
      // if (resp.statusText === "OK") {
      //   //alert("after axios selected designation:"+designation);
      //   setEmployeesData(resp.data.employees);
      //   setEmployeesInitialData(resp.data.employees);
      //   let assignees = resp.data.employees
      //     .map((employee) => employee.employeeid)
      //     .join(",");
      //   setAssigneeValues(assignees);
      //   setModifiedAssignees(assignees);
      //   setIsDeptselected(true);
      //   //   alert(assignees);
      // } else {
      //   console.error("Designation fetch failed");
      // }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const selectDepnChange = async (designationid, designation) => {
    try {
      // deisgnationChangebyDept()
      //alert(designationid);
      desigid = designationid;

      //console.log("inside designation change desigid.." +desigid);

      let selecteddesignation = designationid;
      //alert("selected  designation"+selecteddesignation);
      setDesignation(selecteddesignation);
      //selectInputRef.isMulti=true;
      if (designationid === "0") {
        selectInputRef.current.clearValue();

        return;
      }
      let resp;

      if (role === "ROLE_MANAGER" && userid === "8367") {
        console.log("1111111111111");
        const departmentIds = options.map((dep) => dep.id).join(",");

        resp = await axios.get(
          `${baseURL}/getAllassigneesbydesignationandept?id=${designationid}&spMgr=true&ids=${
            designationid === "All" ? departmentIds : designationid
          }&designation=${"false"}`
        );
        if (resp) {
          setEmployeesData(resp.data.employees);
          setEmployeesInitialData(resp.data.employees);
          let assignees = resp.data.employees
            .map((employee) => employee.employeeid)
            .join(",");
          setAssigneeValues(assignees);
          setModifiedAssignees(assignees);

          let assigneesUserIds = resp.data.employees.map(
            (employee) => employee.user_id
          );
          setModifiedAssigneesUserIds(assigneesUserIds);
          setIsDeptselected(true);
          //   alert(assignees);
        } else {
          console.error("Designation fetch failed");
        }
      } else if (role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR") {
        console.log("222222222");
        resp = await axios.get(
          `${baseURL}/getAllassigneesbydesignationandept?id=` +
            designationid +
            "&did=" +
            selectedDepartmentid +
            "&m=1" +
            "&userid=" +
            userid
        );
        if (resp) {
          //alert("after axios selected designation:"+designation);
          setEmployeesData(resp.data.employees);
          setEmployeesInitialData(resp.data.employees);
          let assignees = resp.data.employees
            .map((employee) => employee.employeeid)
            .join(",");
          setAssigneeValues(assignees);
          setModifiedAssignees(assignees);

          let assigneesUserIds = resp.data.employees.map(
            (employee) => employee.user_id
          );
          setModifiedAssigneesUserIds(assigneesUserIds);
          setIsDeptselected(true);
          //   alert(assignees);
        } else {
          console.error("Designation fetch failed");
        }
      } else {
        resp = await axios.get(
          `${baseURL}/getAllassigneesbydesignationandept?id=` +
            designationid +
            "&did=" +
            selectedDepartmentid +
            "&m=0"
        );
        console.log("33333333333");
        if (resp) {
          //alert("after axios selected designation:"+designation);
          setEmployeesData(resp.data.employees);
          setEmployeesInitialData(resp.data.employees);
          let assignees = resp.data.employees
            .map((employee) => employee.employeeid)
            .join(",");
          setAssigneeValues(assignees);
          setModifiedAssignees(assignees);

          let assigneesUserIds = resp.data.employees.map(
            (employee) => employee.user_id
          );
          setModifiedAssigneesUserIds(assigneesUserIds);
          setIsDeptselected(true);
          //   alert(assignees);
        } else {
          console.error("Designation fetch failed");
        }
      }
      // if (resp.statusText === "OK") {
      //   //alert("after axios selected designation:"+designation);
      //   setEmployeesData(resp.data.employees);
      //   setEmployeesInitialData(resp.data.employees);
      //   let assignees = resp.data.employees
      //     .map((employee) => employee.employeeid)
      //     .join(",");
      //   setAssigneeValues(assignees);
      //   setModifiedAssignees(assignees);
      //   setIsDeptselected(true);
      //   //   alert(assignees);
      // } else {
      //   console.error("Designation fetch failed");
      // }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const selectDeisgChange = async (designationid, designation) => {
    try {
      desigid = designationid;

      let selecteddesignation = designationid;
      setDesignation(selecteddesignation);
      if (designationid === "0") {
        selectInputRef.current.clearValue();

        return;
      }
      let resp;

      if (role === "ROLE_MANAGER" && userid === "8367") {
        console.log("first");

        // const departmentIds = employeeinitalsdata
        //   .map((employee) => ({
        //     value: employee.employeeid,
        //     label: `${employee.FirstName} ${
        //       employee.LastName !== null ? employee.LastName : ""
        //     } - ${employee.employeeid}`,
        //   }))
        //   .map((dep) => dep.value)
        //   .join(",");

        const departmentIds = options.map((dep) => dep.id).join(",");

        // resp = await axios.get(
        //   `${baseURL}/getAllassigneesbydesignationandept?id=${seldepartment}&spMgr=true&ids=${
        //     designationid === "All" ? designationid : departmentIds
        //   }&designation=${"true"}`
        // );
        resp = await axios.get(
          `${baseURL}/getAllassigneesbydesignationandept?id=${seldepartment}&spMgr=true&ids=${
            seldepartment === "All" ? departmentIds : designationid
          }&designation=${"true"}&designationid=${designationid}`
        );
        if (resp) {
          //alert("after axios selected designation:"+designation);
          // console.log(resp.data.employees, "resp.data.employees");
          setEmployeesData(resp.data.employees);
          setEmployeesInitialData(resp.data.employees);
          let assignees = resp.data.employees
            .map((employee) => employee.employeeid)
            .join(",");
          setAssigneeValues(assignees);
          setModifiedAssignees(assignees);

          let assigneesUserIds = resp.data.employees.map(
            (employee) => employee.user_id
          );
          setModifiedAssigneesUserIds(assigneesUserIds);
          setIsDeptselected(true);
          //   alert(assignees);
        } else {
          console.error("Designation fetch failed");
        }
        console.log("1111111111111111111111111111 111111111111111111111111");
      } else if (role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR") {
        console.log(
          "1111111111111111111111111111 22222222222222222222222222222222222"
        );

        console.log("second");
        resp = await axios.get(
          `${baseURL}/getAllassigneesbydesignationandept?id=` +
            designationid +
            "&did=" +
            selectedDepartmentid +
            "&m=1" +
            "&userid=" +
            userid
        );
        if (resp) {
          //alert("after axios selected designation:"+designation);
          setEmployeesData(resp.data.employees);
          setEmployeesInitialData(resp.data.employees);
          let assignees = resp.data.employees
            .map((employee) => employee.employeeid)
            .join(",");
          setAssigneeValues(assignees);
          setModifiedAssignees(assignees);

          let assigneesUserIds = resp.data.employees.map(
            (employee) => employee.user_id
          );
          setModifiedAssigneesUserIds(assigneesUserIds);
          setIsDeptselected(true);
          //   alert(assignees);
        } else {
          console.error("Designation fetch failed");
        }
      } else {
        console.log("third");
        resp = await axios.get(
          `${baseURL}/getAllassigneesbydesignationandept?id=` +
            designationid +
            "&did=" +
            selectedDepartmentid +
            "&m=0"
        );
        if (resp) {
          //alert("after axios selected designation:"+designation);
          setEmployeesData(resp.data.employees);
          setEmployeesInitialData(resp.data.employees);
          let assignees = resp.data.employees
            .map((employee) => employee.employeeid)
            .join(",");
          setAssigneeValues(assignees);
          setModifiedAssignees(assignees);

          let assigneesUserIds = resp.data.employees.map(
            (employee) => employee.user_id
          );
          setModifiedAssigneesUserIds(assigneesUserIds);
          setIsDeptselected(true);
          //   alert(assignees);
        } else {
          console.error("Designation fetch failed");
        }
      }
      // if (resp.statusText === "OK") {
      //   //alert("after axios selected designation:"+designation);
      //   setEmployeesData(resp.data.employees);
      //   setEmployeesInitialData(resp.data.employees);
      //   let assignees = resp.data.employees
      //     .map((employee) => employee.employeeid)
      //     .join(",");
      //   setAssigneeValues(assignees);
      //   setModifiedAssignees(assignees);
      //   setIsDeptselected(true);
      //   //   alert(assignees);
      // } else {
      //   console.error("Designation fetch failed");
      // }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const deisgnationChangebyDept = async (deptid) => {
    try {
      //selectInputRef.current.clearValue();D

      const resp = await axios.get(
        `${baseURL}/getassigneesbydesignationandept?id=All` + "&did=" + deptid
      );
      if (resp) {
        //alert("after axios selected designation:"+designation);
        setEmployeesData(resp.data.employees);

        setEmployeesInitialData(resp.data.employees);
        let assignees = resp.data.employees
          .map((employee) => employee.employeeid)
          .join(",");
        setAssigneeValues(assignees);
        setModifiedAssignees(assignees);

        let assigneesUserIds = resp.data.employees.map(
          (employee) => employee.user_id
        );
        setModifiedAssigneesUserIds(assigneesUserIds);
        setIsDeptselected(true);
        //   alert(assignees);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const getValue = () => {
    let newopt = [];

    if (designation === "All" && deptid === "All") {
      console.log("ddata is gotted");
      newopt = employeeinitalsdata.map((employee) => ({
        value: employee.id,
        label: `${employee.FirstName} ${
          employee.LastName !== null ? employee.LastName : ""
        } - ${employee.employeeid}`,
        user_id: employee.user_id,
      }));
    } else if (
      designation !== "All" &&
      designation !== "0" &&
      deptid === "All"
    ) {
      console.log("ddata is gotted");
      newopt = employeeinitalsdata.map((employee) => ({
        value: employee.id,
        label: `${employee.FirstName} ${
          employee.LastName !== null ? employee.LastName : ""
        } - ${employee.employeeid}`,
        user_id: employee.user_id,
      }));
    }
    if (selectedOptions && selectedOptions.length > 0) {
      console.log("nothing 1");
      return selectedOptions;
    } else if (isdeptselected) {
      if (deptid !== "All") {
        console.log("ddata is gotted");
        newopt = employeeinitalsdata.map((employee) => ({
          // value: employee.id,
          value: employee.employeeid,
          label: `${employee.FirstName} ${
            employee.LastName !== null ? employee.LastName : ""
          } - ${employee.employeeid}`,
          user_id: employee.user_id,
        }));
      }
    } else {
      console.log("nothing");
      return [];
    }
    return newopt;
  };
  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      // Perform form submission with the stored form data
      console.log("Submitting form:", formData);

      const response = await axios.post(
        `${baseURL}/api/smartgoal/create`,
        formData
      );

      if (response.status === 200) {
        // Reset form data and close modal after successful submission
        setFormData(null);
        setShowModal(false);
        setShowToast(true);

        setTimeout(() => {
          setShowToast(false);
          navigate("/goals");
        }, 3000);

        // Redirect to the desired page
        // window.location.href = "/goals"; // Update "/goals" with the desired URL
      } else {
        // Handle the case where the form submission fails
        console.error("Form submission failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  function getLastDayOfYear(date) {
    const year = date.getFullYear();
    // const lastDay = new Date(year, 12, 31);
    let lastDay = new Date();
    lastDay.setFullYear(year);
    lastDay.setMonth(11, 31); // December is 11 in JavaScript
    return lastDay.toISOString().substr(0, 10);
  }

  return (
    <>
      <Formik
        initialValues={{
          title: "",
          startdate: new Date().toISOString().substr(0, 10),
          enddate: getLastDayOfYear(new Date()),
          description: "",
          departmentid: "",
          designation: "",
          progress: "0",
          assignees: [],
          user_id: [],
          year: currentYear,
        }}
        validationSchema={Yup.object({
          title: Yup.string().required("Title is required"),
          description: Yup.string().required("Description is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
        }) => (
          <div className="container">
            {/* <h4 className="text-start  pb-2">ADD KPI</h4> */}
            <div className="col-lg-12  mt-1 m-5">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-5">
                    <label>
                      Select Department<span className="text-danger">*</span>
                    </label>
                    <select
                      disabled={isManager}
                      className="form-select form-control"
                      name="departmentid"
                      value={(values.departmentid = selectedDepartmentid)}
                      onChange={(e) => {
                        departmentChange(e.target.value);
                        setSelDepartment(e.target.value);
                        // for department change
                        setSelctedDepartmentid(e.target.value);

                        selectDepnChange(
                          isSpMgr ? e.target.value : "All",
                          "Not Designation"
                        );
                      }}
                    >
                      {options.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.departmentname}
                        </option>
                      ))}
                    </select>
                    {/* <select
                      disabled={isManager}
                      className="form-select form-control"
                      name="departmentid"
                      // value={values.departmentid} // ✅ bind to Formik
                      value={(values.departmentid = selectedDepartmentid)}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // ✅ update Formik
                        setFieldValue("departmentid", newValue);

                        // ✅ update your local state if you still need it
                        setSelDepartment(newValue);
                        setSelctedDepartmentid(newValue);
                        departmentChange(newValue);
                        selectDepnChange(
                          isSpMgr ? newValue : "All",
                          "Not Designation"
                        );
                      }}
                    >
                      {options.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.departmentname}
                        </option>
                      ))}
                    </select> */}

                    {touched.departmentid && errors.departmentid ? (
                      <div className="text-danger">{errors.departmentid}</div>
                    ) : null}
                  </div>
                  <div className="col-lg-5 ml-5">
                    <img src={SmartGoalimg} width="300" alt="Form_Image" />
                  </div>
                  <h5 className="text-start pb-2 ">SMART KPI </h5>
                  <div className="col-lg-5 ">
                    <label className="formlabel">
                      Title <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.title && errors.title ? "is-invalid" : ""
                      }`}
                      placeholder="Enter title"
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.title && errors.title ? (
                      <div className="text-danger">{errors.title}</div>
                    ) : null}
                  </div>

                  <div className="col-lg-5  ml-5">
                    <label>Start Date</label>
                    <br />
                    <input
                      type="date"
                      className="form-control"
                      name="startdate"
                      onChange={handleChange}
                      defaultValue={
                        values.startdate ||
                        new Date().toISOString().substr(0, 10)
                      }
                    ></input>
                  </div>

                  <div className="col-lg-5 mt-2">
                    <label>Description</label>
                    <textarea
                      className={`form-control ${
                        touched.description && errors.description
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter description"
                      name="description"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                    {touched.description && errors.description ? (
                      <div className="text-danger">{errors.description}</div>
                    ) : null}
                  </div>

                  <div className="col-lg-5 mt-2 ml-5">
                    <label>End Date</label>
                    <br />
                    <input
                      type="date"
                      className="form-control"
                      name="enddate"
                      onChange={handleChange}
                      defaultValue={
                        values.enddate || getLastDayOfYear(new Date())
                      }
                    ></input>
                  </div>

                  <div className="col-lg-5 mt-2">
                    <label>Select Designation</label>
                    <input
                      type="hidden"
                      name="designationid"
                      value={(values.designation = designation)}
                    />
                    <select
                      className="form-select form-control"
                      name="role"
                      placeholder="Select Designation"
                      value={(values.role = designation)}
                      onChange={(e) => {
                        handleRemoveAllOptions();

                        setFieldValue("designation", e.target.value);
                        setDesignation(e.target.value);
                        selectDeisgChange(
                          isSpMgr ? e.target.value : "All",
                          "designation"
                        );
                        selectDeisgChange(e.target.value, "designation");
                      }}
                    >
                      <option value="All" selected>
                        All Designations
                      </option>
                      {designationData.map((option) => {
                        console.log(option, "kkkkkkkkk");
                        // Logs each option

                        return (
                          <option key={option.id} value={option.id}>
                            {option.designation}
                          </option>
                        );
                      })}
                    </select>

                    {/* <select
                      className="form-select form-control"
                      name="designation"
                      value={values.designation} // ✅ bind to Formik
                      onChange={(e) => {
                        const newValue = e.target.value;

                        setFieldValue("designation", newValue); // ✅ Formik
                        setDesignation(newValue); // ✅ local state (if still needed)

                        handleRemoveAllOptions();

                        selectDeisgChange(
                          isSpMgr ? newValue : "All",
                          "designation"
                        );
                      }}
                    >
                      <option value="">All Designations</option>
                      {designationData.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.designation}
                        </option>
                      ))}
                    </select> */}

                    {touched.designation && errors.designation ? (
                      <div className="text-danger">{}</div>
                    ) : null}
                  </div>

                  {/* <div className="col-lg-5 mt-2 ml-5">
                    <label>
                      Select Assignees <span className="text-danger">*</span>
                    </label>
                    <Select
                      isMulti
                      name="assignees"
                      options={employeesData.map((employee) => ({
                        value: employee.id,
                        label: `${employee.FirstName} ${employee.LastName}`,
                      }))}
                      value={employeesData.map((employee) => ({
                        value: employee.id,
                        label: `${employee.FirstName} ${employee.LastName}`,
                      }))} // Select all options by default
                      onChange={(selectedOption) => {
                        const selectedValues = selectedOption
                          ? selectedOption.map((option) => option.value)
                          : [];
                        setFieldValue("assignees", selectedValues);
                      }}
                    />

                    {touched.assignees && errors.assignees ? (
                      <div className="text-danger">{errors.assignees}</div>
                    ) : null}
                  </div> */}

                  <div className="col-lg-5 mt-2 ml-5">
                    <label>
                      Select Assignees <span className="text-danger">*</span>
                    </label>
                    <Select
                      ref={selectInputRef}
                      isMulti
                      name="assignees2"
                      options={employeeinitalsdata.map((employee) => ({
                        value: employee.employeeid,
                        label: `${employee.FirstName} ${
                          employee.LastName !== null ? employee.LastName : ""
                        } - ${employee.employeeid}`,
                        user_id: employee.user_id,
                      }))}
                      value={getValue()}
                      onChange={(selectedOptions) => {
                        // setAssigneevalues(selectedValues.join(","));

                        setSelectedOptions(selectedOptions);

                        let finalIds = selectedOptions
                          .map((employee) => {
                            return employee.value;
                          })
                          .join(",");

                        setModifiedAssignees(finalIds);
                        setFieldValue("assignees", finalIds);
                        setFieldValue("assignees2", finalIds);

                        const userIds = selectedOptions.map(
                          (employee) => employee.user_id
                        );

                        setModifiedAssigneesUserIds(userIds);

                        console.log("User IDs:", userIds);
                        setFieldValue("user_id", userIds);

                        setIsDeptselected(false);
                        //  isassigneeselected(true);
                      }}
                    />
                    {touched.assignees && errors.assignees ? (
                      <div className="text-danger">{errors.assignees}</div>
                    ) : null}
                  </div>

                  <input
                    type="hidden"
                    name="assignees"
                    //employeeinitalsdata.map((employee) => employee.id).join(",")
                    value={
                      (values.assignees = modifiedAssignees
                        ? modifiedAssignees
                        : null)
                    }
                  />
                  <input
                    type="hidden"
                    name="user_id"
                    //employeeinitalsdata.map((employee) => employee.id).join(",")
                    value={
                      (values.user_id = modifiedAssigneesUserIds
                        ? modifiedAssigneesUserIds
                        : null)
                    }
                  />
                  <input
                    type="hidden"
                    value={modifiedAssignees}
                    name="modifiedassignees"
                  ></input>

                  {/* <div className="col-lg-5 mt-2 ">
                  <label>Progress (%)</label><br />
                  <input
                    type="number"
                    className='form-control'

                    min={0}
                    max={100}
                    name='progress'
                    onChange={handleChange}
                    value={values.progress}
                  ></input>
                </div> */}
                  <div className="col-lg-5 mt-2">
                    <label>Progress (%)</label>
                    <br />
                    <input
                      type="number"
                      className="form-control"
                      min={0}
                      max={100}
                      name="progress"
                      onChange={(e) => {
                        const value = Math.min(parseInt(e.target.value), 100);
                        setProgress(value.toString());
                      }}
                      value={(values.progress = progress)}
                    />
                  </div>
                </div>
                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a className="text-decoration-none " href="/goals">
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you Confirm this Changes</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirmSubmit}>
            Yes
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}

export default MainGoal;
